









import Login from './components/Login.vue';
import AppBar from './components/AppBar.vue';
import { Component, Vue } from 'vue-property-decorator';
import { auth } from './firebaseConfig';
import User from './models/User';

@Component({
  components: {
    AppBar
  }
})
export default class App extends Vue {}
